import { useMemo } from 'react';

const useFiltersDisableSettings = (
  filters: $TSFixMe,
  {
    ratesTags = false,
    stayLength = false,
    budget = false,
    dateRange = false,
    travelerInterest = false
  }
) => {
  const ratesTagsSettings = useMemo(() => {
    return ratesTags
      ? {
          rateTagsSettings: {
            ...filters.rateTagsSettings,
            disabled: true
          },
          rateTagsColumnSettings: {
            ...filters.rateTagsColumnSettings,
            className: 'filterColumn'
          }
        }
      : {};
  }, [ratesTags, filters.rateTagsSettings, filters.rateTagsColumnSettings]);

  const stayLengthSettings = useMemo(() => {
    return stayLength
      ? {
          stayLengthSettings: {
            ...filters.stayLengthSettings,
            disabled: true
          },
          stayLengthColumnSettings: {
            ...filters.stayLengthColumnSettings,
            className: 'filterColumn'
          }
        }
      : {};
  }, [stayLength, filters.stayLengthSettings, filters.stayLengthColumnSettings]);

  const budgetDisableSettings = useMemo(() => {
    return budget
      ? {
          budgetSettings: {
            ...filters.budgetSettings,
            disabled: true
          },
          budgetColumnSettings: {
            ...filters.budgetColumnSettings,
            className: 'filterColumn'
          }
        }
      : {};
  }, [budget, filters.budgetColumnSettings, filters.budgetSettings]);

  const dateRangeDisableSettings = useMemo(() => {
    return dateRange
      ? {
          dateRangeSettings: {
            ...filters.dateRangeSettings,
            disabled: true,
            inputItem: { ...filters.dateRangeSettings.inputItem, disabled: true }
          },
          dateRangeColumnSettings: {
            ...filters.dateRangeColumnSettings,
            className: 'filterColumn'
          }
        }
      : {};
  }, [dateRange, filters.dateRangeColumnSettings, filters.dateRangeSettings]);

  const travelerInterestDisableSettings = useMemo(() => {
    if (filters.travelerInterestSettings) {
      const travelerInterestSettings = {};
      Object.keys(filters.travelerInterestSettings).forEach((key) => {
        filters.travelerInterestSettings[key] = {
          ...filters.travelerInterestSettings[key],
          disabled: travelerInterest
        };
      });
      return travelerInterestSettings;
    }
    return {};
  }, [filters.travelerInterestSettings, travelerInterest]);

  const filtersDisableSettings = useMemo(() => {
    return {
      ...ratesTagsSettings,
      ...stayLengthSettings,
      ...budgetDisableSettings,
      ...dateRangeDisableSettings,
      ...travelerInterestDisableSettings
    };
  }, [
    ratesTagsSettings,
    stayLengthSettings,
    budgetDisableSettings,
    dateRangeDisableSettings,
    travelerInterestDisableSettings
  ]);

  return filtersDisableSettings;
};

export default useFiltersDisableSettings;
